import React from 'react'

const FooterHeaders = ({text}) => {
  return (
    <div className='fw-bold text-white'>{text}</div>
  )
}

export default FooterHeaders